import { defineNuxtPlugin } from '#app';
import type { Wording } from '@qic/entities';

import { WORDINGS } from '@qic/constants';

const wordingApiAdapter = (wording: typeof WORDINGS[number]): Wording => ({
  categoryCode: wording.categoryID,
  categoryName: wording.category,
  name: wording.docFullName,
  url: wording.Link,
  coverCode: wording.coverCode,
  shortName: wording.docShortName,
  productCode: wording.productCode,
});


export default defineNuxtPlugin(async (nuxtApp) => {
  const wordings = WORDINGS.map(wordingApiAdapter);
  const map =
    new Map((wordings).map(wording => [wording.shortName, wording.url]));

  nuxtApp.provide('wordings', wordings);
  nuxtApp.provide('wordingsMap', map);
});
